"use client";

import React from "react";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";
import { FlaskConical } from "lucide-react";
import { cn } from "@/lib/utils";
import Link from "next/link";
import { env } from "@/config/env";

const INACTIVE_COLOR = "#6e7787";

// Define your POC routes here
const POC_LINKS = [
  {
    name: "Moodboard Generator",
    path: "/moodboard",
    description: "Generate moodboards based on product themes and attributes.",
  },
  {
    name: "Product Categorization",
    path: "/categorization",
    description: "Automatically categorize products.",
  },
];

const POCsDropdown = () => {
  const [open, setOpen] = React.useState(false);
  const environment = env.NEXT_PUBLIC_ENVIRONMENT;

  // Hide POCs dropdown in production and beta environments
  if (environment == "prod" || environment == "beta") {
    return null;
  }

  return (
    <HoverCard openDelay={0} open={open} onOpenChange={setOpen}>
      <HoverCardTrigger
        onClick={(e) => {
          e.stopPropagation();
          setOpen(!open);
        }}
      >
        <div
          className={cn(
            "flex flex-col cursor-pointer gap-y-0.5 items-center text-xs text-[#6e7787] hover:text-primary",
          )}
        >
          <FlaskConical size={22} color={INACTIVE_COLOR} />
          <span className="mt-0.5">POCs</span>
        </div>
      </HoverCardTrigger>
      <HoverCardContent className="w-64 p-2">
        <div className="space-y-1">
          <h4 className="text-sm font-semibold mb-2 px-2">Proof of Concepts</h4>
          {POC_LINKS.map((poc) => (
            <Link
              key={poc.path}
              href={poc.path}
              className="block px-2 py-2 rounded-md hover:bg-gray-100 transition-colors"
              onClick={() => setOpen(false)}
            >
              <div className="text-sm font-medium text-gray-900">
                {poc.name}
              </div>
              <div className="text-xs text-gray-500">{poc.description}</div>
            </Link>
          ))}
        </div>
      </HoverCardContent>
    </HoverCard>
  );
};

export default POCsDropdown;
